import {
  faCircleCheck,
  faPlayCircle,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectLastPlayedLesson } from "../../redux/personaliseLessons/nameSlice";
import { Mixpanel } from "../../config/Mixpanel";
import constants from "../PersonaliseLessons/utilities/constants";
import { toast } from "react-toastify";
import { faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { Line } from "rc-progress";

const CourseSyllabus = ({ courseModule, courseName }) => {
  const [showCourse, setShowCourse] = useState([
    true,
    ...Array(
      courseModule?.course_data?.length > 0
        ? courseModule?.course_data?.length - 1
        : 0,
    ).fill(false),
  ]);
  const setLastWatchedLesson = useSelector(selectLastPlayedLesson);
  const navigate = useNavigate();

  const handleClick = (index, lessonName) => {
    Mixpanel.track(constants.Mixpanel.COURSE_LIST_PAGE_CLICKED_ON_LESSON);
    navigate(
      `/personalise/${encodeURIComponent(courseName)}/${
        courseModule?.course_data?.[index]?.module_slug
      }/${lessonName}`,
    );
  };

  const handleShowCourse = (index) => {
    setShowCourse((prevLessons) => {
      const updatedLessons = [...prevLessons];
      updatedLessons[index] = !prevLessons[index];
      return updatedLessons;
    });
  };

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    let formattedTime = "";

    if (hours > 0) {
      formattedTime += hours + " hr ";
    }

    if (minutes > 0) {
      formattedTime += minutes + " min";
    }

    return formattedTime.trim();
  }

  return (
    <div>
      <h2 className="text-2xl font-semibold">Course Syllabus</h2>
      {courseModule?.course_data?.map((item, index) => {
        const noOfQuizIncomplete = item?.module_content?.filter(
          (lesson) => lesson?.lesson_status !== "completed",
        )?.length;
        const percentage =
          100 * (1 - noOfQuizIncomplete / item?.module_content?.length);
        return (
          <div
            key={index}
            className="mt-3 cursor-pointer rounded-xl bg-[#2D4F71] p-3"
            onClick={() => {
              if (!item?.is_locked) {
                handleShowCourse(index);
              } else if (
                index > 0 &&
                courseModule?.course_data?.[index - 1]?.module_progress === 100
              ) {
                toast.warning("Loading your Module. Please wait!");
              } else {
                toast.warning(
                  "Complete previous module to unlock this module.",
                );
              }
            }}
          >
            <div className="flex items-center gap-3">
              {item?.module_progress === 100 ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="text-2xl text-[#00C838]"
                />
              ) : item?.module_progress > 0 ? (
                <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#F59E0B]">
                  <FontAwesomeIcon
                    icon={faExclamation}
                    className="text-xl text-[#F59E0B]"
                  />
                </div>
              ) : (
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Pending_1.png?updatedAt=1689672495417"
                  alt=""
                  width={24}
                  height={24}
                />
              )}
              <div className="flex flex-1 flex-col">
                <div className="flex items-center">
                  <div className="flex-1">
                    <h3 className="font-semibold leading-5">
                      {item?.module_name}
                    </h3>
                    <div className="flex items-center text-sm text-[#92B3BE]">
                      <p className="mr-2">
                        {item?.module_content?.length} lessons
                      </p>
                      <div className="mr-2 h-1 w-1 rounded-full bg-[#92B3BE]"></div>
                      <p>
                        {item?.module_duration
                          ? formatTime(item?.module_duration)
                          : formatTime(item?.module_content?.length * 15 * 60)}
                      </p>
                    </div>
                  </div>
                  {item?.is_locked && (
                    <div className="h-6 w-6">
                      <img
                        src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Lock_6.svg?updatedAt=1689232670218"
                        alt=""
                        className="h-full w-full"
                      />
                    </div>
                  )}
                  <div className="ml-2 flex items-center">
                    {!showCourse[index] ? (
                      <img
                        src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Chevron_4.png?updatedAt=1689672710809"
                        width={20}
                        height={20}
                        alt=""
                      />
                    ) : (
                      <img
                        src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Chevron_4__1_.png?updatedAt=1689672788505"
                        width={20}
                        height={20}
                        alt=""
                      />
                    )}
                  </div>
                </div>
                {!item?.is_locked && item?.module_progress !== 100 && (
                  <div className="flex w-full items-center gap-2">
                    <p className="text-nowrap text-sm text-[#92B3BE]">
                      {noOfQuizIncomplete} Quiz
                      {noOfQuizIncomplete > 1 ? "zes" : ""} Left!
                    </p>
                    <div className="max-md:flex-1 w-full md:w-1/3">
                      <Line
                        percent={percentage}
                        strokeColor={"#F59E0B"}
                        trailColor="#FFE2B0"
                        strokeWidth={2.5}
                        trailWidth={2.5}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {showCourse[index] ? (
              <div className="mt-3">
                {item?.module_content?.map((lesson, indexNo) => (
                  <div
                    key={indexNo}
                    className="mb-4 flex cursor-pointer"
                    onClick={() => handleClick(index, lesson?.lesson_slug)}
                  >
                    <div className="relative h-14 w-20">
                      <img
                        src={lesson?.thumbnail_url}
                        alt=""
                        className={`h-auto w-full rounded-[11px] ${
                          lesson?.lesson_status === "completed" && "blur-[2px]"
                        } ${
                          lesson?.lesson_status !== "completed" &&
                          lesson?.lesson_status !== "" &&
                          "border-2 border-[#F59E0B]"
                        } ${lesson?.lesson_status === "" && "opacity-50"}`}
                      />
                      {lesson?.lesson_status === "completed" ? (
                        <div className="absolute left-1/2 top-1/2 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full border-2 border-[#54A3F5]">
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="text-sm font-bold text-[#54A3F5]"
                            style={{ strokeWidth: 2 }}
                          />
                        </div>
                      ) : setLastWatchedLesson === lesson?.lesson_id ? (
                        <FontAwesomeIcon
                          icon={faPlayCircle}
                          className="absolute inset-0 mx-auto my-auto text-lg text-[#00C838]"
                        />
                      ) : lesson?.lesson_status === "" ? (
                        <FontAwesomeIcon
                          icon={faPlayCircle}
                          className="absolute inset-0 mx-auto my-auto text-lg"
                        />
                      ) : lesson?.lesson_status === "inprogress" ||
                        lesson?.lesson_status === "quizpending" ? (
                        <div className="absolute inset-0 mx-auto my-auto flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#F59E0B]">
                          <FontAwesomeIcon
                            icon={faExclamation}
                            className="text-sm font-bold text-[#F59E0B]"
                            style={{ strokeWidth: 2 }}
                          />
                        </div>
                      ) : null}
                    </div>
                    <div
                      className={`ml-3 w-[75%] ${
                        lesson?.intro_text?.length > 0
                          ? ""
                          : "flex flex-col justify-center"
                      }`}
                    >
                      <h4 className="font-semibold leading-5 line-clamp-2">
                        {lesson?.lesson_name}
                      </h4>
                      {lesson?.intro_text?.length > 0 ? (
                        lesson?.intro_text?.length > 100 ? (
                          <p className="text-xs text-white/50">
                            {lesson?.intro_text?.substring(0, 97)}...
                          </p>
                        ) : (
                          <p className="text-xs text-white/50">
                            {lesson?.intro_text}
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default CourseSyllabus;
